var _style, _path, _path2, _path3, _path4, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHockey5S(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Hockey5s_Court",
    xmlns: "http://www.w3.org/2000/svg",
    width: 953,
    height: 568,
    viewBox: "0 0 953 568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n      .center-left {fill: var(--field-center-left-color);}\r\n      .center-right {fill: var(--field-center-right-color);}\r\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "center-right",
    id: "Left_Possession",
    "data-name": "Left_Possession",
    d: "M479,6Zm-6,562H953V0H473Z",
    transform: "translate(0 0.001)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "center-left",
    id: "Right_Possession",
    "data-name": "Right_Possession",
    d: "M479,6Zm-6,562H953V0H473Z",
    transform: "translate(-473 0.001)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Left_Border",
    "data-name": "Left_Border",
    d: "M6,6H474V562H6ZM0,568H480V0H0Z",
    transform: "translate(0 0.001)",
    fill: "#434a51"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Right_Border",
    "data-name": "Right_Border",
    d: "M479,6H947V562H479Zm-6,562H953V0H473Z",
    transform: "translate(0 0.001)",
    fill: "#434a51"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Left_Goal",
    "data-name": "Left_Goal",
    width: 6,
    height: 90,
    transform: "translate(0 239)",
    fill: "#e60019"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Right_Goal",
    "data-name": "Right_Goal",
    width: 6,
    height: 90,
    transform: "translate(947 239)",
    fill: "#e60019"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHockey5S);
export default __webpack_public_path__ + "static/media/hockey5s.648c2c5d92cf0ea5627eed0b2ce6bbf5.svg";
export { ForwardRef as ReactComponent };